export function getPercentage(num, percentage) {
  const result = (num / percentage) * 100;
  return `${parseFloat(result.toFixed(2))}%`;
}

export const formatPercent = (num, val = 0) => {
  return Math.round(num * 100).toFixed(val);
};
